import * as Yup from "yup";
import { addressValidationSchema, financeAddressValidationSchema } from "components/Address/validationSchema";

const PHONE_NUMBER_VALIDATION = new RegExp(
  /^(((\+44\s?\d{4}|\(?0\d{4}\)?)\s?\d{3}\s?\d{3})|((\+44\s?\d{3}|\(?0\d{3}\)?)\s?\d{3}\s?\d{4})|((\+44\s?\d{2}|\(?0\d{2}\)?)\s?\d{4}\s?\d{4}))(\s?\#(\d{4}|\d{3}))?$/
);

const baseShape = {
  email: Yup.string()
    .email("Please enter a valid email")
    .required("Please enter email address"),
  telephone1: Yup.string()
    .transform((value) => {
      return value ? value.replace(/\s+/g, "") : value;
    })
    .required("Please enter phone number")
    .max(14, "Please enter a valid phone number")
    .matches(PHONE_NUMBER_VALIDATION, "Please enter a valid phone number"),
  title: Yup.string().required("Please select title"),
  forename: Yup.string().required("Please enter first name"),
  surname: Yup.string().required("Please enter surname"),
  isManualAddress: Yup.boolean().oneOf([true], "Please select address"),
};

const keeperRequiredShape = {
  year: Yup.string().required("Please select year"),
  vehicle_keeper: Yup.string()
    .max(50, "Please enter valid keeper")
    .required("Please enter keeper"),
};

const keeperOptionalShape = {
  year: Yup.string().optional(),
  vehicle_keeper: Yup.string()
    .max(50, "Please enter valid keeper")
    .optional(),
};

export const validationSchema = Yup.object()
  .shape({ ...baseShape, ...keeperRequiredShape })
  .concat(addressValidationSchema);

export const validationSchemaKeeperOptional = Yup.object()
  .shape({ ...baseShape, ...keeperOptionalShape })
  .concat(addressValidationSchema);

export const newAddressViewValidationSchema = Yup.object()
  .shape({ ...baseShape, ...keeperRequiredShape })
  .concat(financeAddressValidationSchema);

export const newAddressViewValidationSchemaKeeperOptional = Yup.object()
  .shape({ ...baseShape, ...keeperOptionalShape })
  .concat(financeAddressValidationSchema);

export const deliveryAndTransferValidationSchema = Yup.object().shape({
  delivery_type: Yup.string().required("Please select delivery type"),
  transfer_type: Yup.string().required("Please select transfer type"),
});
